import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#business-loan-refinance-app', App);
